import { AddAlertComponent } from '../alerts/components/addAlertComponent/AddAlertComponent';
import { AlertWatchlistComponent } from '../alerts/components/alertWatchlistComponent/AlertWatchlistComponent';
import { AlertChartComponent } from '../alerts/components/chartComponent/AlertChartComponent';
import { AlertNotificationComponent } from '../alerts/components/notificationComponent/AlertNotificationComponent';
import { WatchlistManagerComponent } from '../alerts/components/watchlistManagerComponent/WatchlistManagerComponent';
import { TradePlanHub } from '../newTradingInterface/tradePlanHub/TradePlanHub';

export const gridLayoutComponentMap = {
  alertWatchlist: AlertWatchlistComponent, 
  addAlert: AddAlertComponent,
  watchlistManager: WatchlistManagerComponent,
  chart: AlertChartComponent,
  notifications: AlertNotificationComponent,
  tradePlanHub: TradePlanHub,
};
